import {$, T} from "../../common/drupal/drupal";

class Home {
	
	/**
	 * Initialize event listeners
	 */
	init () {
		// Slide products home
		$('.NodeHome-products-products:not(.swiper-container)').each(function () {
			$(this).addClass('swiper-container').find('.ProductList-item').addClass('swiper-slide').wrapAll('<div class="swiper-wrapper"/>');
			$(this).append('<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>');
			var homeSlide = new Swiper($(this), {
				slidesPerView: 'auto',
				speed: 500,
				watchOverflow: true,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		});
		
		// homepage: click on arrow to scroll down
		$('.NodeHome-presentation .btn-down').on('click', function () {
			$('body,html').animate({
				scrollTop: $('.NodeHome-presentation').outerHeight(),
			}, 600);
		});
		
		// if page is already scrolled on load
		let body = document.getElementsByTagName('body')[0];
		if (window.scrollY > 0) {
			body.classList.add('js-scrolled');
		}
		function scrollActions() {
			let windowY = (window.scrollY) ? window.scrollY : window.pageYOffset;
			if (windowY > 0) {
				body.classList.add('js-scrolled');
			} else {
				body.classList.remove('js-scrolled');
			}
		}
		// Detect if scrolled
		window.addEventListener('scroll', function () {
			requestAnimationFrame(scrollActions);
		});
	}
	
	attach(context) {
		this.init(context);
	}
}

export let home = new Home();
